import { Component, Inject, Input } from '@angular/core';
import { HealthAnalysisTimelineEventModel } from '../../../model/health-analysis-timeline-event.model';
import { HEALTH_ANALYSIS_JOURNEY_STEPS } from '../../../health-analysis-journey-steps.const';
import { AbstractComponent } from '../../../../../../shared/definition/abstract/abstract.component';
import { HealthAnalysisJourneyStepEnum } from '../../../enum/health-analysis-journey-step.enum';

@Component({
  selector: 'app-health-analysis-detail-timeline',
  templateUrl: './health-analysis-detail-timeline.component.html',
  styleUrl: './health-analysis-detail-timeline.component.scss'
})
export class HealthAnalysisDetailTimelineComponent extends AbstractComponent{
    @Input() timeline: Array<HealthAnalysisTimelineEventModel>;

    journeySteps = HEALTH_ANALYSIS_JOURNEY_STEPS();
    expandedEvent = new Set<string>;

    public eventExpandEvent(eventId: string): void {
        if (this.expandedEvent.has(eventId)) {
            this.expandedEvent.delete(eventId);
        } else {
            this.expandedEvent.add(eventId);
        }
    }
    public getElementFields(element: Record<string, any>): Array<{ key: string, value: string }> {
        const fields: Array<{ key: string, value: string }> = [];
        for (const key in element) {
            if (element.hasOwnProperty(key)) {
                let value = element[key];
                if (['updatedAt', 'createdAt'].includes(key) || value.toString().match(/[0-9]{4}-[0-9]{2}-[0-9]{2}/g)) {
                    const date = (new Date(value));
                    value = date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
                }
                fields.push({ key, value: JSON.stringify(value, null, 2).replace(/^"/, '').replace(/"$/, '') });
            }
        }

        return fields;
    }
}
